export default {
  title: 'Changed while you were editing',
  descriptionConflicts: 'This data was saved in the meantime. Click the value you want to keep for each field that you changed as well.',
  descriptionServerChanges: 'This data was saved in the meantime. These changes are applied together with yours. Revert any you do not want to keep.',
  notSaved: 'Not saved',
  field: 'Field',
  keepAll: 'Keep all values',
  keeping: 'Keeping this',
  you: 'You',
  combined: 'Keep both (server version first)',
  added: 'Added',
  removed: 'Removed',
  missing: 'Not present',
  value: 'Value',
  positionStart: 'At start',
  positionAfter: 'After {item}',
  resolvedCount: '{resolved} of {total} conflict resolved | {resolved} of {total} conflicts resolved',
  saveDisabled: 'Choose a value for {count} more field | Choose a value for {count} more fields',
  serverChanges: 'Changes in server version without conflict: {count}',
  show: 'Show changes',
  hide: 'Hide changes',
  revert: 'Revert change',
  restore: 'Restore change',
  reverted: 'Your value is kept',
  cancelTooltip: 'Discard your changes and continue editing the server version',
  latestMissing: 'This data was deleted on the server while you were editing. Your changes cannot be saved.',
  version: {
    original: 'Original version',
    latest: 'Server version',
    edited: 'Your version',
  },
};
